import { TabType } from '@/components/common/TagTabs/TagTabs';
import ContractHeadersContainer from '../ContractHeaders.container';
import ParentCompanyContainer from '../../ParentCompany/ParentCompany.container';
import Uplifts from '../../Uplifts/Uplifts';
import UpliftCapsContainer from '../../Uplifts/UpliftCaps/UpliftCaps.container';
import ContractPartiesContainer from '../../ContractParties/ContractParties.container';
import SalesOrdersTabContainer from '../../SalesOrdersTab/SalesOrdersTab.container';
import ContractTCsContainer from '../../ContractTCs/ContractTCs.container';
import ContractIqContainer from '../../ContractIq/ContractIq.container';
import { EnvUtils } from '@/utils/env.utils';

const contractDetailsTabs: TabType[] = [
  {
    title: 'Header',
    name: 'Contract-Header',
    ContentComponent: ContractHeadersContainer
  },
  ...(EnvUtils.isBillingTabContractHeaderEnabled() ? [{
    title: 'Billing',
    name: 'Billing',
    ContentComponent: ParentCompanyContainer
  }] : []),
  {
    title: 'Uplifts',
    name: 'Uplifts',
    ContentComponent: EnvUtils.isUpliftCapsEnabled() ? UpliftCapsContainer : Uplifts
  },
  {
    title: 'Sales Orders',
    name: 'Sales-Orders',
    ContentComponent: SalesOrdersTabContainer
  },
  {
    title: 'Contract Parties',
    name: 'Contract-Parties',
    ContentComponent: ContractPartiesContainer
  },
  ...(EnvUtils.isContractTCsEnabled() ? [{
    title: 'Contract T&Cs',
    name: 'Contract-TCs',
    ContentComponent: ContractTCsContainer
  }] : []),
  {
    title: 'Contract IQ',
    name: 'Contract-IQ',
    ContentComponent: ContractIqContainer
  },
];

const hiddenFromProd: TabType[] = [];

export const getContractDetailsTabs = (): TabType[] => {
  return [...contractDetailsTabs, ...(EnvUtils.azureEnvIs('production') ? [] : hiddenFromProd)];
};
